export default "__VITE_ASSET__DVnVBy4A__"